import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuickRepliesContainer, QuickReplyButton } from 'src/styled/Chat/ChatInput.styled';
import { IQuickReply } from 'src/utils/contextualReplies';

interface IQuickRepliesProps {
  onSelect: (text: string) => void;
  replies?: IQuickReply[];
}

export const QuickReplies: React.FC<IQuickRepliesProps> = ({ onSelect, replies }) => {
  const { t } = useTranslation();

  const defaultReplies: IQuickReply[] = [
    { key: 'help', label: t('chat.quickReplies.help') },
    { key: 'leaveBalance', label: t('chat.quickReplies.leaveBalance') },
    { key: 'remotePolicy', label: t('chat.quickReplies.remotePolicy') },
    { key: 'officeRules', label: t('chat.quickReplies.officeRules') },
    { key: 'meetingRooms', label: t('chat.quickReplies.meetingRooms') }
  ];

  const displayReplies = replies || defaultReplies;

  if (!displayReplies || displayReplies.length === 0) {
    return null;
  }

  return (
    <QuickRepliesContainer>
      {displayReplies.map((reply, index) => (
        <QuickReplyButton
          key={index}
          onClick={() => onSelect(reply.message || reply.label)}
          aria-label={`${t('chat.send')}: ${reply.label}`}>
          {reply.label}
        </QuickReplyButton>
      ))}
    </QuickRepliesContainer>
  );
};

export default QuickReplies;
